import React from "react"
import PropTypes from 'prop-types'

const Loading = ({
  style = {},
  height = "75%",
  width = "100%",
  className = "building",
  viewBox = "0 0 100 100"
}) => (
  <svg
    height={height}
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <g transform="translate(50,50)">
      <circle cx="0" cy="0" r="10" fill="none" stroke="#456caa" strokeWidth="2" strokeDasharray="31.41592653589793 31.41592653589793" transform="rotate(359.878)">
        <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="0" repeatCount="indefinite"></animateTransform>
      </circle>
      <circle cx="0" cy="0" r="20" fill="none" stroke="#88a2ce" strokeWidth="2" strokeDasharray="62.83185307179586 62.83185307179586" transform="rotate(67.1035)">
        <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.25" repeatCount="indefinite"></animateTransform>
      </circle>
      <circle cx="0" cy="0" r="30" fill="none" stroke="#c2d2ee" strokeWidth="2" strokeDasharray="94.24777960769379 94.24777960769379" transform="rotate(174.234)">
        <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.5" repeatCount="indefinite"></animateTransform>
      </circle>
      <circle cx="0" cy="0" r="40" fill="none" stroke="#e4ebf7" strokeWidth="2" strokeDasharray="125.66370614359172 125.66370614359172" transform="rotate(284.314)">
        <animateTransform attributeName="transform" type="rotate" values="0 0 0;360 0 0" times="0;1" dur="1s" calcMode="spline" keySplines="0.2 0 0.8 1" begin="-0.75" repeatCount="indefinite"></animateTransform>
      </circle>
    </g>
  </svg>
)
//#fefefe
Loading.propTypes = {
  style: PropTypes.object,
  height: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Loading
